import React from 'react';
import { menuData } from '../constants/menu';
import LendoIcon from './LendoIcon';

const LendoMenuDesktop = () => {
  return (
    <div className="lendo-menu-desktop">
      <div className="main-nav">
        {menuData.mainNav.map((section) => (
          <div key={section.title} className="nav-section">
            <h3 className="section-title">{section.title}</h3>
            <div className="links">
              {section.links.map((link) => (
                <a key={link.text} href={link.url} className="nav-link">
                  <LendoIcon name={link.icon} size='40px' />
                  <div className="link-content">
                    <div className="link-title">{link.text}</div>
                    <div className="link-subtitle">{link.subtitle}</div>
                  </div>
                  <LendoIcon name="icon/arrow-right-green" size="18px" className="arrow-icon" />
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="secondary-nav">
        {menuData.secondaryNav.map((section) => (
          <div key={section.title} className="nav-section">
            <h3 className="section-title">{section.title}</h3>
            <div className="links">
              {section.links.map((link) => (
                <a key={link.text} href={link.url} className="nav-link secondary">
                  <span className="link-text">{link.text}</span>
                  <LendoIcon name="icon/arrow-right-green" size="18px" className="arrow-icon" />
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LendoMenuDesktop;
